import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const LIVE_CLASSES_ICON_GRADIENT = 'navigationLiveClassesGradient';

export const LiveClassesIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1999 2.24854C6.53716 2.24854 5.9999 2.78579 5.9999 3.44854V4.64854H4.7999C3.47442 4.64854 2.3999 5.72305 2.3999 7.04854V19.0485C2.3999 20.374 3.47442 21.4485 4.7999 21.4485H19.1999C20.5254 21.4485 21.5999 20.374 21.5999 19.0485V7.04854C21.5999 5.72305 20.5254 4.64854 19.1999 4.64854H17.9999V3.44854C17.9999 2.78579 17.4626 2.24854 16.7999 2.24854C16.1372 2.24854 15.5999 2.78579 15.5999 3.44854V4.64854H8.3999V3.44854C8.3999 2.78579 7.86264 2.24854 7.1999 2.24854ZM7.1999 8.24854C6.53716 8.24854 5.9999 8.78579 5.9999 9.44854C5.9999 10.1113 6.53716 10.6485 7.1999 10.6485H16.7999C17.4626 10.6485 17.9999 10.1113 17.9999 9.44854C17.9999 8.78579 17.4626 8.24854 16.7999 8.24854H7.1999Z"
      />
      <defs>
        <linearGradient
          id={LIVE_CLASSES_ICON_GRADIENT}
          x1="17.7264"
          y1="24.3881"
          x2="4.93599"
          y2="0.725822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D00068" />
          <stop offset="1" stopColor="#FF6EB6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const SPath = styled.path`
  fill: #a5aac5;

  ${onLightTheme`
    fill: rgb(var(--ln-content) / 0.6);
  `}

  .active & {
    fill: url(#${LIVE_CLASSES_ICON_GRADIENT});
  }
`;
